
import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import _, { noop } from 'underscore';
import classNames from 'classnames';
import { withCustomValidation } from '@bingads-webui-react/validation';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { ImpressionTrackingUrlOptions as ImpressionTrackingView} from '@bingads-webui-campaign/audience-campaign-shared';

const extractImpressionTrackingSetting = (verifiedTrackingData) => {
  if (_.isArray(verifiedTrackingData) && verifiedTrackingData.length === 2) {
    return verifiedTrackingData;
  }
  return ['', ''];
};

export const formatImpressionTrackingSetting = (campaignSettings, i18n) => {
  const [advertiserEntityID, publisherEntityID] = extractImpressionTrackingSetting(_.get(campaignSettings, '[0].VerifiedTrackingSettings[0].VerifiedTrackingData[0].Data.Values'));
  return (
    <div white-space="pre">
      <div>{i18n.getString(_TL_('Advertiser entity ID: ')) + (advertiserEntityID === '' ? i18n.getString(_TL_('None')) : advertiserEntityID)}</div>
      <div>{i18n.getString(_TL_('Publisher entity ID: ')) + (publisherEntityID === '' ? i18n.getString(_TL_('None')) : publisherEntityID)}</div>
    </div>
  );
};

const ImpressionTrackingSetting = ({
  i18n,
  campaignSettings,
  updateValidation,
}) => {
  const classes = useDefaultStyles();

  const [impressionTrackingSettingRef, setImpressionTrackingSettingRef] = useState();

  const impressionTrackingView1 = useMemo(() => {
    const impressionTrackingView = new ImpressionTrackingView({
      i18n,
      isEnabledForVerifiedImpressionTrackingAtCampaignLevel: true,
      initialIASImpressionTrackingUrlValue: extractImpressionTrackingSetting(_.get(campaignSettings, '[0].VerifiedTrackingSettings[0].VerifiedTrackingData[0].Data.Values')),
      isImpressionTrackingUrlSectionVisible: false,
      isForBrandAwarenessCampaign: true,
    });

    impressionTrackingView.render();

    return impressionTrackingView;
  });

  useEffect(() => {
    if (impressionTrackingSettingRef) {
      impressionTrackingSettingRef.innerHTML = '';
      impressionTrackingSettingRef.append(impressionTrackingView1.el);

      impressionTrackingView1.on('IASInputChange', (value) => {
        updateValidation([], {
          VerifiedTrackingData: value,
        });
      });
    }

    return noop;
  }, [impressionTrackingSettingRef]);

  return (
    <div className={classNames(['impression-tracking-setting-picker', classes.pickerContainer])} >
      <div className={classNames(['impression-tracking-setting-view'])} ref={newRef => setImpressionTrackingSettingRef(newRef)} />
    </div>
  );
};

ImpressionTrackingSetting.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  campaignSettings: PropTypes.shape(PropTypes.string).isRequired,
  updateValidation: PropTypes.func.isRequired,
};

const validatedImpressionTrackingSetting = withCustomValidation(ImpressionTrackingSetting);

export { validatedImpressionTrackingSetting as ImpressionTrackingSetting };
